

<div class="search-fields-settings search-querybuilder-popup">
  <div class="pop-header">
    <div class="left">
      <img src="/assets/css/images/platform/modify-settings.png" />
      <label class="label">{{translate('galis_js_SearchForm_SearchLabelQueryBuilder')}}</label>
    </div>
    <div class="right" (click)="closeQueryBuilder()">
      <img src="/assets/css/images/platform/close-icon.png" />
    </div>
  </div>

  <div class="title-div">
    <label class="fields-main-label">{{translate('galis_js_QueryBuilderPopup_MainLabel')}}</label>
  </div>  

  <div class="query-builder-popup-container">
    <query-builder class="sem-query-builder" [(ngModel)]='queryBuilderModel' [emptyMessage]="'WebGalis_QueryBuilder_EmptyRuleGroupMessage'" [config]='queryBConfig'></query-builder>
  </div>

  <div class="footer">    
    <div class="right-footer">
      <div class="save" (click)="applyQueryBuilder()">
        <span>{{translate('galis_js_QueryBuilderPopup_ApplyButtonLabel')}}</span>
      </div>
      <div class="cancel cancel-mid" (click)="resetQueryBuilder()">
        <span>{{translate('galis_js_QueryBuilderPopup_ResetButtonLabel')}}</span>
      </div>
      <div class="cancel" (click)="closeQueryBuilder()">
        <span>{{translate('galis_js_QueryBuilderPopup_CancelButtonLabel')}}</span>
      </div>
    </div>
  </div>
</div>
